import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Countdown } from '@/components/Countdown';

import { ScBonusCardTimer } from './styled';

const SECONDS_IN_DAY = 86_400;

export interface BonusCardTimerProps {
  timeLeft: number;
}

export const BonusCardTimer: FC<BonusCardTimerProps> = ({ timeLeft }) => {
  const { t } = useTranslation(['bonuses', 'common']);

  const isDaysShown = useMemo(() => timeLeft > SECONDS_IN_DAY, [timeLeft]);

  return (
    <ScBonusCardTimer $isUrgent={!isDaysShown}>
      {t('bonuses:expiringIn')}{' '}
      <Countdown dual timeLeft={timeLeft}>
        {({ days, hours, minutes, seconds }) => (
          <>
            {isDaysShown && (
              <>
                {days}
                {t('common:timer.dd')[0]}:
              </>
            )}
            {hours}
            {t('common:timer.hh')[0]}:{minutes}
            {t('common:timer.mm')[0]}:{seconds}
            {t('common:timer.ss')[0]}
          </>
        )}
      </Countdown>
    </ScBonusCardTimer>
  );
};
